export default __webpack_public_path__ + "static/media/Group 16705.ca870bd3.svg";